export const SEA_QUERY_CACHE_KEY = "get_sea_saved_cards_infinite_query";
export const SEA_FILTERED_CARDS_QUERY_CACHE_KEY = "get_sea_filtered_saved_cards_infinite_query";
